module.exports = __webpack_public_path__ + "img/lieyunwang.8d5c8585.png";